// Date formatting utilities with IST timezone

export const formatDateIST = (dateString, options = {}) => {
  if (!dateString) return '-';
  
  const defaultOptions = {
    timeZone: 'Asia/Kolkata',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...options
  };
  
  try {
    return new Date(dateString).toLocaleDateString('en-IN', defaultOptions);
  } catch (e) {
    return '-';
  }
};

export const formatTimeIST = (dateString, options = {}) => {
  if (!dateString) return '-';
  
  const defaultOptions = {
    timeZone: 'Asia/Kolkata',
    hour: '2-digit',
    minute: '2-digit',
    ...options
  };
  
  try {
    return new Date(dateString).toLocaleTimeString('en-IN', defaultOptions);
  } catch (e) {
    return '-';
  }
};

export const formatDateTimeIST = (dateString, options = {}) => {
  if (!dateString) return '-';
  
  const defaultOptions = {
    timeZone: 'Asia/Kolkata',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...options
  };
  
  try {
    return new Date(dateString).toLocaleString('en-IN', defaultOptions);
  } catch (e) {
    return '-';
  }
};

export const formatFullDateTimeIST = (dateString) => {
  if (!dateString) return '-';
  
  try {
    return new Date(dateString).toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (e) {
    return '-';
  }
};
